module.exports = __webpack_public_path__ + "img/cs_logo-commonshare.65a365a.gif";